import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllMatchesOddsCricketAPI,
  getBetCountAPI,
} from "../service/cricket";
import moment from "moment";

const Matches = ({ isUpcoming }) => {
  const dispatch = useDispatch();
  const [selectedGame, setSelectedGame] = useState("Cricket");
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.account.userData);
  const [cricketMatches, setCricketMatches] = useState([]);
  const [activeTab, setActiveTab] = useState("Cricket"); // State to keep track of active tab
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const naviagte = useNavigate();
  const getCricketMatches = async () => {
    const { response, code } = await getAllMatchesOddsCricketAPI();
    console.log("getCricketMatches", response);
    if (code == 200) {
      response.map((item) => {
        return item;
      });
      setCricketMatches(response);
    }
  };
  useEffect(() => {
    let interval;

    getCricketMatches();

    interval = setInterval(() => {
      getCricketMatches();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  const navigateToGame = (gameEvent) => {
    if (!userData?.token) {
      dispatch({
        type: "accountData/setLoginPopSate",
        payload: true,
      });
      return;
    }
    naviagte(`/game/cricket/${gameEvent["cricketId"]}`, {
      state: { gameEvent },
    });
  };

  return (
    <main>
      <div>
        <div className="container">
          {cricketMatches.map((item) => (
            <div className="sepr">
              <a onClick={() => navigateToGame(item)} >
                <div
                  className="row"
                  style={{
                    background: "rgb(255, 255, 255)",
                    paddingBottom: 5,
                    paddingTop: 5,
                    borderBottom: "1px solid blue",
                  }}
                >
                  <div className="col-xs-6 col-md-2 center">
                    <img
                      src="https://hrx99.com/images/inplay.png"
                      style={{ width: 120 }}
                    />
                  </div>
                  <div
                    className="col-xs-6 col-md-2"
                    style={{
                      fontWeight: 800,
                      fontSize: 16,
                      color: "rgb(95, 101, 99)",
                    }}
                  >
                    {moment(item?.eventTime).format("DD-MM-YYYY hh:mm A")}
                  </div>
                  <div className="col-xs-12 col-md-12">
                    <h3 className="oflow">
                      <div className="blinking-green" />
                      {item?.eventName}
                    </h3>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Matches;
